var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('nav-bar',{attrs:{"title":"使用说明"}}),_c('div',{staticClass:"margin-lr"},[_c('div',{staticClass:"rich-text",domProps:{"innerHTML":_vm._s(_vm.info.description)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }